export default "__VITE_ASSET__f6HRkDqg__"